export enum CarryingFeatureType {
  DANGEROUS = '0cdf34d8-2256-4c49-98fa-eefece14c51e'
}
